import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import {
  IonContent, IonHeader, IonPage, IonButtons, IonMenuButton,
  IonTitle,
  IonToolbar, IonList, IonItem, IonLabel, IonSegment, IonSegmentButton, onIonViewDidEnter
} from '@ionic/vue';
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth.store';
import EmptyState from './components/EmptyState.vue';
import ListSkeletton from './components/ListSkeletton.vue';
import { rangeDateText } from '@/helpers/date';
import { getApi } from '@/helpers/api';
import { PeriodTeamsApi, DtoPersonnelTeamLink } from 'ppf-api-client';



export default /*#__PURE__*/_defineComponent({
  __name: 'TeamsPage',
  setup(__props) {

let teams: DtoPersonnelTeamLink[] = [];
const loading = ref(true);
const filter = ref<'current' | 'history'>('current');
const filteredList = ref<DtoPersonnelTeamLink[]>([]);

const service = getApi(PeriodTeamsApi);
const auth = useAuthStore();
const now = new Date();

//load inital data when entering the tab
onIonViewDidEnter(() => {
  loading.value = true;
  teams = [];
  
  service.periodTeamsByPersonnel(auth.userId).then(r => {
    teams = r;
    loading.value = false;
    reloadList();
  });
});

//filter change callback will reload the list
const filterChanged = (e: any) => {
  filter.value = e.target.value;
  reloadList();
}

//reload the list by applying the filter and default sort
const reloadList = () => {
  filteredList.value = teams
    .filter(c => filter.value == 'current' ? (!c.end || c.end >= now || c.end.getTime() == 0) : (c.end && c.end.getTime() > 0 && c.end < now))
    .sort((a, b) => {
      const at = a.start ? a.start.getTime() : 0;
      const bt = b.start ? b.start.getTime() : 0;
      return bt - at
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton))
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('p.team.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSegment), {
            value: filter.value,
            onIonChange: filterChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSegmentButton), { value: "current" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('g.current')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "history" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('g.history')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_unref(IonList), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (c) => {
                return (_openBlock(), _createBlock(_unref(IonItem), {
                  key: c.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      slot: "start",
                      class: "fa fa-circle fa-sm fa-fw",
                      style: _normalizeStyle({ color: c.color || '#000' })
                    }, null, 4),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(c.name), 1),
                        _createElementVNode("p", null, _toDisplayString(_unref(rangeDateText)(c.start, c.end)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(ListSkeletton, {
            style: _normalizeStyle({ display: loading.value ? 'block' : 'none' })
          }, null, 8, ["style"]),
          _createVNode(EmptyState, {
            style: _normalizeStyle({ display: loading.value || filteredList.value.length > 0 ? 'none' : 'block' }),
            icon: "fa-users"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('p.team.empty')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})